import { defineMessages, MessageDescriptor } from 'react-intl';

type TargetMessages = {
  phrasebook: MessageDescriptor;
};

export const ar: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ar',
  },
});

export const da: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_da',
  },
});

export const de: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_de',
  },
});

export const el: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_el',
  },
});

export const en: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_en',
  },
});

export const en_us: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_en_us',
  },
});

export const es: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_es',
  },
});

export const es_mx: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_es_mx',
  },
});

export const fa: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_fa',
  },
});

export const fr: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_fr',
  },
});

export const he: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_he',
  },
});

export const hi: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_hi',
  },
});

export const id: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_id',
  },
});

export const is: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_is',
  },
});

export const it: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_it',
  },
});

export const jp_full: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_jp_full',
  },
});

export const jp_romaji: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_jp_romaji',
  },
});

export const ko: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ko',
  },
});

export const mn: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_mn',
  },
});

export const nl: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_nl',
  },
});

export const no: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_no',
  },
});

export const pl: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pl',
  },
});

export const pt: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pt',
  },
});

export const pt_br: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_pt_br',
  },
});

export const ru: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_ru',
  },
});

export const sl: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sl',
  },
});

export const sv: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sv',
  },
});

export const sw: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_sw',
  },
});

export const th: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_th',
  },
});

export const tr: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_tr',
  },
});

export const uk: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_uk',
  },
});

export const yo: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_navigation_phrasebook_yo',
  },
});

export const zh_cn: TargetMessages = defineMessages({
  phrasebook: {
    id: 'seo_phrasebook_zh_cn',
  },
});
